import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import CustomCheckbox from '../../shared/CustomCheckbox';
import CustomSwitch from '../../shared/CustomSwitch';

const useStyles = makeStyles({
  title: {
    fontFamily: 'Lato',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22.4px',
  },
  deptMainBox: {
    width: '100%',
    minHeight: '48px',
    padding: '0 12px',
    borderRadius: '2px',
    border: '1px solid rgba(228, 231, 236, 1)',
    background: '#fefefe',
    margin: '16px 0 0 0',
    flexWrap: 'wrap',
  },
  deptBox: {
    paddingLeft: '10px',
  },
  roleBoxMain: {
    width: '100%',
    minHeight: '250px',
    padding: '12px',
    borderRadius: '2px',
    border: '1px solid rgba(228, 231, 236, 1)',
    background: '#fefefe',
    marginTop: '16px',
    flexWrap: 'wrap',
  },
  roleBox: {
    paddingLeft: '10px',
    height: '100%',
  },
});

const Department = ({ department, handleSelectAllRoles, handleCheckbox, setMandatoryFn }) => {
  const classes = useStyles();
  return (
    <Grid item>
      <Grid container direction="column">
        <Grid container direction="row" className={classes.deptMainBox} alignItems="center">
          {department.map((item) => {
            const allSelected = item.roles.every((role) => role.selected);
            const someSelected = item.roles.some((role) => role.selected) && !allSelected;

            return (
              <Grid item xs={3} className={classes.deptBox} key={item.id}>
                <CustomCheckbox
                  selected={allSelected}
                  indeterminate={someSelected}
                  value={item.id}
                  label={item.title}
                  size="14px"
                  weight="600"
                  handleChange={(e) => handleSelectAllRoles(item.id, e.target.checked)}
                />
              </Grid>
            );
          })}
        </Grid>

        {/* Role Checkboxes + Mandatory Switch */}
        <Grid container direction="row" className={classes.roleBoxMain} alignItems="flex-start">
          {department.map((dept) => (
            <Grid item xs={3} className={classes.roleBox} key={dept.id}>
              <Grid container direction="column">
                {dept.roles.map((role) => (
                  <Grid
                    item
                    key={role.id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '8px',
                    }}
                  >
                    <CustomCheckbox
                      value={role.id}
                      label={role.title}
                      selected={role.selected}
                      size="12px"
                      weight="500"
                      name="departmentRoleIds"
                      handleChange={handleCheckbox}
                    />
                    {role.selected && (
                      <CustomSwitch name={role.id.toString()} checked={role.mandatory} handleChange={setMandatoryFn} />
                    )}
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Department;
